import { ImageName } from "../../../../mcleod-ui-common/images/src";
import { ButtonProps, ButtonVariant, ComponentTypes, SearchButton } from "@mcleod/components";

const buttonProps: Partial<ButtonProps> = {
    backgroundColor: "transparent",
    variant: ButtonVariant.round,
    imageWidth: 26,
    imageHeight: 26,
    imageName: ImageName.magnifyingGlass,
    caption: null,
    width: null,
    minWidth: null,
    height: null,
    padding: 0,
    margin: 0
}

export class AppSearchButton extends SearchButton {
    protected constructor(props?: Partial<ButtonProps>) {
        super(props);
        if (this._designer == null) {
            // If a specialized caption is being provided,
            // show the button per //web ui implementation for now.
            if (props.caption == null)
                this.setProps({ ...buttonProps, imageColor: props.imageColor ?? "primary" });
        }
    }
}

ComponentTypes.registerAppComponentType("searchbutton", {
    constructor: AppSearchButton.prototype.constructor,
    isCompound: false
});
